export const freeTools = [
  "ai-clothes-changer",
  "ai-face-editor",
  "ai-gif-generator",
  "ai-headshot-generator",
  "ai-image-generator",
  "ai-image-upscaler",
  "ai-meme-generator",
  "ai-photo-editor",
  "ai-qr-code-generator",
  "ai-talking-photo",
  "auto-subtitle-generator",
  "face-detector",
  "face-swap/image",
  "face-swap/video",
  "image-background-remover",
  "lip-sync",
  "photo-colorizer",
] as const;

export type FreeTool = (typeof freeTools)[number];

export const freeToolStatuses = {
  queued: "QUEUED",
  pending: "PENDING",
  starting: "STARTING",
  outOfCredit: "OUT_OF_CREDIT",
  success: "SUCCESS",
  error: "ERROR",
  failure: "FAILURE",
};
